import { UserRole } from "src/app/planvue-api"
import { UserForm } from "./user-form.component"


export type FieldControls = { 
  fields: { [F in keyof UserForm]: boolean }
  allowDeletion: boolean,
  allowSave: boolean,
  allowPasswordReset: boolean,
  permitted_roles: UserRole[]
}

type PermissionsMatrix = Partial<{ 
  [R in UserRole]: { 
    [P in UserRole]: FieldControls
  }
}>

const ALLOW_ALL = { 
  fields: 
    { 
      first_name: true,
      last_name: true,
      email: true,
      role: true,
      organization: true,
      active: true,
      expiration_date: true,
      venues: true,
    },
  allowDeletion: true,
  allowPasswordReset: true,
  allowSave: true,
  permitted_roles: ["admin","power","user","lite"] as UserRole[]
}

const ALLOW_NONE = { 
  fields: 
    { 
      first_name: false,
      last_name: false,
      email: false,
      role: false,
      organization: false,
      active: false,
      expiration_date: false,
      venues: false,
    },
  allowDeletion: false,
  allowPasswordReset: false,
  allowSave: false,
  permitted_roles: [] as UserRole[]
}

const ALLOW_POWER_EDIT = { 
  fields: 
    { 
      first_name: true,
      last_name: true,
      email: true,
      role: true,
      organization: true,
      active: true,
      expiration_date: true,
      venues: true,
    },
  allowDeletion: true,
  allowPasswordReset: true,
  allowSave: true,
  permitted_roles: ["user", "lite"] as UserRole[]
}


export const PlanVueAuthMatrix: PermissionsMatrix = {
  admin: { 
    admin: ALLOW_ALL,
    power: ALLOW_ALL,
    user: ALLOW_ALL,
    lite: ALLOW_ALL
  },
  power: { 
    admin: ALLOW_NONE,
    power: ALLOW_ALL,
    user: ALLOW_POWER_EDIT,
    lite: ALLOW_POWER_EDIT,
  },
  user: { 
    admin: ALLOW_NONE, 
    power: ALLOW_NONE,
    user: ALLOW_NONE,
    lite: ALLOW_NONE,
  },
  lite: { 
    admin: ALLOW_NONE,
    power: ALLOW_NONE,
    user: ALLOW_NONE,
    lite: ALLOW_NONE,
  }
}

export const SelfEditPermissions : FieldControls  = { 
  fields: 
    { 
      first_name: true,
      last_name: true,
      email: true,
      role: false,
      organization: true,
      active: false,
      expiration_date: false,
      venues: false,
    },
  allowDeletion: false,
  allowPasswordReset: false,
  allowSave: true,
  permitted_roles: ["admin","lite","power","user"] as UserRole[]
}